// Ionic & Angular Imports
import {Component} from '@angular/core';
import {Events, NavParams, LoadingController, Loading, ModalController, AlertController, Refresher} from 'ionic-angular';

// Service Imports 
import {rsReportSvc, ReportState } from '../../../../services/report.service';
import {rsPhotoSvc, Photo } from '../../../../services/photo.service';

// Component Imports
import {BasePage} from '../../../base.component';
import {PictureModal} from './picture-modal/picture-modal.component';
//import {ActivityModal} from './activity-modal/activity-modal.component';

@Component({
    templateUrl: 'picture.html',
    providers: [
        rsPhotoSvc
    ]
})
export class PicturePage extends BasePage
{
    // Class variables 
    private contentList : Photo[];

    // Class Constructor
    constructor( 
        protected alertCtrl : AlertController, 
        private loadingCtrl : LoadingController,  
        private navParams : NavParams, 
        private eventSystem : Events, 
        private modalCtrl : ModalController,
        private reportSvc: rsReportSvc, 
        private photoSvc : rsPhotoSvc,
    ){
        // Construct base class
        super(alertCtrl);

        // Retrieve the activity list from our NavParams       
        this.contentList = this.navParams.get('content');
        this.sortContentList();

        // Register our event handlers 
        this.registerEventHandlers( eventSystem ); 
    }

    // Class method used to subscribe to all events this class is interested in
    private registerEventHandlers( eventSystem : Events ) {
        eventSystem.subscribe( 'picture:deleted', (data) => { this.deletePicture( data ); });
        eventSystem.subscribe( 'picture:updated', (data) => { this.updatePicture( data ); });
        eventSystem.subscribe( 'picture:added',   (data) => { this.addPicture( data ); });
    } 
        
    // Sorting method for ensuring our ContentList is always sorted by id (ie., oldest to newest entries)
    private sortContentList(reverse : boolean = false) {
        this.contentList.sort( (a,b) => {
            return reverse ? b.id - a.id : a.id - b.id;
        });
    }

    // Class method used to add a new activity to our ContentList 
    private addPicture( photo : Photo ) : boolean {
        // Add this activity to the end of our ContentList
        console.log('photo added:  ', photo );  
        let length : number = this.contentList.push(photo);

        // Finally, publish an event that our report has been updated
        this.eventSystem.publish( 'report:updated', ReportState.Pictures, length );      
        
        // Return successful
        return true;  
    }

    // Class method used to update an activity in our ContentList
    private updatePicture( photo : Photo ) : boolean {
        // Loop through each item in the ContentList to attempt to find a matching activity
        for( var idx = 0; idx < this.contentList.length; idx++ ) {
            let item : Photo = this.contentList[idx];
            if( item.id === photo.id ) {
                // Update the content of this activity within the ContentList
                this.contentList[idx] = photo;
                return true;          
            }
        }
        // No match was found, return false 
        return false;
    }

    // Class method used to delete an activity in our ContentList
    private deletePicture( photo : Photo ) : boolean {
        // Loop through each item in the ContentList to attempt to find a matching activity
        for( var idx = 0; idx < this.contentList.length; idx++ ) {
            let item : Photo = this.contentList[idx];
            if( item.id === photo.id ) {
                // Remove this activity from the ContentList
                this.contentList.splice( idx, 1 );

                // Publish an event that will update our report state 
                this.eventSystem.publish( 'report:updated', ReportState.Pictures, this.contentList.length );

                // Return successful
                return true;          
            }
        }
        // No match was found, return false 
        return false;
    }

    // Class method used by the template to edit an existing activity
    public updateContent( photo : Photo ) {
        // Create our ModalInstance and configure for editing
        this.modalCtrl.create( PictureModal, { 
            photo: photo,
            editmode: true
        }).present();
    }

    // Class method used by the template to create a new activity
    public createContent( ) {
          // Create our ModalInstance and configure for creating 
        this.modalCtrl.create( PictureModal, { 
            photo: null,
            editmode: false
        }).present();      
    }

    // Class method used by the template to delete an activity
    public deleteContent( photo : Photo) {
        // Verify that we have a valid activity id before trying to delete 
        if( photo.id > 0 ) 
        {
            // Activity id is valid; instantiate delete confirmation
            this.displayConfirmation( 'Delete Picture', 'Are you sure you want to delete this picture from this report?', () => 
            {
                // User confirmed- so let's initiate the delete process
                let loader : Loading = this.loadingCtrl.create( {
                    content: 'Deleting...'
                });
                loader.present().then( () => {
                    // Data hNow let's start our delete process 
                    this.photoSvc.deletePhoto( photo.id, this.reportSvc.getActiveReportId() ).subscribe( result => {
                        // Data has been received from our service 
                        this.eventSystem.publish('picture:deleted', photo );
                    }, err => {
                        // Operation failed; dismiss loader and shown an error message 
                        loader.dismiss().then( () => {
                            this.displayError("There was an error deleting this picture.  Please try again later.");
                        });
                    }, () => {
                        // Operation succeeded, dismiss loader
                        loader.dismiss();
                    });
                });
            });
        } else {
            // The activity id supplied is not valid; display a generic error 
            this.displayError( 'An error has occurred.  Please try again later.' );
        }
    }

    // Class method used by the template to refresh the ContentList
    public refreshContent( refresher : Refresher ) {
        // Spawn a spinner while the ContentList is being refreshed
        let loader : Loading = this.loadingCtrl.create( {
            content: 'Refreshing...'
        });
        loader.present().then( () => {
            // The spinner is loaded, so let's get our refreshed ContentList
            this.photoSvc.getPhotos( this.reportSvc.getActiveReportId() )
            .subscribe( result => {
                // Data was received from our service 
                this.contentList = result;
                this.sortContentList();

                // Publish an event that will update our report state 
                this.eventSystem.publish( 'report:updated', ReportState.Pictures, this.contentList.length );
            }, err => {
                // The operation failed, so let's handle this error 
                loader.dismiss().then( () => {
                    this.displayError( "There was an error refreshing the list.  Please try again later." ).then( () => {
                        refresher.complete();
                    });
                });
            }, () => {
                // The operation succeeded, let's dismiss our spinner and complete our refresh operation 
                loader.dismiss().then( () => {
                    refresher.complete();
                });
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/pages/report/tab-main/picture/picture.component.ts